import { SideNavLayout } from "common/layouts/SideNavLayout";
import { StandardLayout } from "common/layouts/StandardLayout";
import { experienceActions } from "data/resources/experiences";
import { interfaceBase } from "lib/styleguide/base.scss";
import React from "react";
import { connect, Provider } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import { Billing } from "../Billing";
import { Details } from "../Details";
import { CopyExperienceDialog, COPY_EXPERIENCE_DIALOG } from "../dialogs/CopyExperienceDialog";
import { DeleteExperienceDialog, DELETE_EXPERIENCE_DIALOG } from "../dialogs/DeleteExperienceDialog";
import { LoadableExperienceShow } from "../ExperienceShow";
import { Config } from "../ExperienceShow/Config";
import { Guests } from "../Guests";
import { GuidePage } from "../GuidePage";
import { Messages } from "../Messages";
import { Overview } from "../Overview";
import { PrintGuide } from "../PrintGuide";
import { initStore } from "../redux/initStore";
import { RoutesPage } from "../RoutesPage";
import { ShortcutQR } from "../ShortcutQR";
import { ExperiencesSideNav } from "./ExperiencesSideNav";

export const getExperienceId = (props) => parseInt(props.match?.params.experienceId, 10);

export const sharedDroppableStyle = (isDraggingOver) =>
  isDraggingOver
    ? {
        border: "2px dashed #6982FF",
        borderBottom: "0px",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
      }
    : null;

export const sharedPlaceholderStyle = (isDraggingOver) =>
  isDraggingOver
    ? {
        border: "2px dashed #6982FF",
        borderTop: "0px",
        borderLeft: "0px",
        borderRight: "0px",
        borderBottomLeftRadius: "5px",
        borderBottomRightRadius: "5px",
      }
    : null;

const store = initStore();

const DataLayer = ({ children }) => <Provider store={store}>{children}</Provider>;

class _ExperiencesApp extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dialog: null,
    };
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    if (getExperienceId(prevProps) !== getExperienceId(this.props)) {
      this.loadData();
    }
  }

  loadData() {
    this.props.loadExperience();
    this.props.loadLastPackage().catch((error) => {
      if (error.details.length > 0 && error.details[0].error_code === "not_found") {
        // the experience has never been published
      }
    });
  }

  showDialog = (dialog) => {
    this.setState({ dialog });
  };

  hideDialog = () => {
    this.setState({ dialog: null });
  };

  render() {
    const { children } = this.props;
    const { dialog } = this.state;
    const experienceId = getExperienceId(this.props);

    return (
      <SideNavLayout nav={<ExperiencesSideNav experienceId={experienceId} showDialog={this.showDialog} />} greyBg>
        <div className={interfaceBase}>{children}</div>
        {dialog === DELETE_EXPERIENCE_DIALOG && (
          <DeleteExperienceDialog experienceId={experienceId} onRequestClose={this.hideDialog} />
        )}
        {dialog === COPY_EXPERIENCE_DIALOG && (
          <CopyExperienceDialog experienceId={experienceId} onRequestClose={this.hideDialog} />
        )}
      </SideNavLayout>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const experienceId = getExperienceId(ownProps);
  return {
    loadExperience: () => dispatch(experienceActions.read(experienceId)),
    loadLastPackage: () => dispatch(experienceActions.lastPackage(experienceId)),
  };
};

const ExperiencesApp = withRouter(connect(null, mapDispatchToProps)(_ExperiencesApp));

const PrintApp = ({ children }) => <Provider store={store}>{children}</Provider>;

// shorthand
const Wrapped = ({ w: W, wp, c: C }) => (
  <W {...wp}>
    <C />
  </W>
);

export const routes = ({ match: { path } }) => (
  <DataLayer>
    <Route path={`${path}/:experienceId`}>
      {({ match: { path: innerPath } }) => (
        <Switch>
          <Route path={innerPath} exact>
            <Wrapped w={StandardLayout} wp={{ greyBg: true }} c={LoadableExperienceShow} />
          </Route>
          <Route path={`${innerPath}/view_config`}>
            <Wrapped w={StandardLayout} wp={{ greyBg: true }} c={Config} />
          </Route>
          <Route path={`${innerPath}/billing`}>
            <Wrapped w={StandardLayout} wp={{ greyBg: true }} c={Billing} />
          </Route>
          <Route path={`${innerPath}/print_guide`}>
            <Wrapped w={PrintApp} c={PrintGuide} />
          </Route>
          <Route path={`${innerPath}/details`}>
            <Wrapped w={ExperiencesApp} c={Details} />
          </Route>
          <Route path={`${innerPath}/messages`}>
            <Wrapped w={ExperiencesApp} c={Messages} />
          </Route>
          <Route path={`${innerPath}/routes`}>
            <Wrapped w={ExperiencesApp} c={RoutesPage} />
          </Route>
          <Route path={`${innerPath}/guide`}>
            <Wrapped w={ExperiencesApp} c={GuidePage} />
          </Route>
          <Route path={`${innerPath}/guests`}>
            <Wrapped w={ExperiencesApp} c={Guests} />
          </Route>
          <Route path={`${innerPath}/edit`}>
            <Wrapped w={ExperiencesApp} c={Overview} />
          </Route>
          <Route path={`${innerPath}/shortcut`}>
            <Wrapped w={ExperiencesApp} c={ShortcutQR} />
          </Route>
        </Switch>
      )}
    </Route>
  </DataLayer>
);
